module.exports = __webpack_public_path__ + "static/media/unavailable.5c1b6fe2.svg";